'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FileDetails = require('./FileDetails');

var _FileDetails2 = _interopRequireDefault(_FileDetails);

var _FileProgress = require('./FileProgress');

var _FileProgress2 = _interopRequireDefault(_FileProgress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// const {
//   hasHover, message, isSaving,
//   savedProgress, savedValue, style, uploadStarted, value, ...rest,
// } = props
// const savedTxt = 'Processing...'
// <div>
//   <FileUploading isSaving={isSaving} savedProgress={savedProgress} value={value} />
//   {savedValue && <p>{savedTxt}<strong>{savedValue}</strong></p>}
// </div>
function FileUploading(_ref) {
  var isSaving = _ref.isSaving,
      savedProgress = _ref.savedProgress,
      value = _ref.value;
  var dataUrl = value.dataUrl,
      name = value.name;
  // const { dataUrl, ...dimensions } = image

  var waitTxt = 'Calculating sha1 and preparing for upload.';

  return _react2.default.createElement(
    'div',
    { className: 'dz-preview dz-processing dz-image-preview col-md-2' },
    _react2.default.createElement(_FileDetails2.default, value),
    !isSaving && _react2.default.createElement(
      'p',
      null,
      waitTxt
    ),
    isSaving && _react2.default.createElement(
      'p',
      null,
      'Saving'
    ),
    dataUrl && _react2.default.createElement(
      'div',
      null,
      dataUrl && _react2.default.createElement('img', { alt: name, src: dataUrl, style: { width: 300 }, width: 300 })
    ),
    savedProgress && isSaving && _react2.default.createElement(_FileProgress2.default, { savedProgress: savedProgress })
  );
}
FileUploading.propTypes = {
  isSaving: _propTypes2.default.bool.isRequired,
  value: _propTypes2.default.object.isRequired,
  savedProgress: _propTypes2.default.number.isRequired
};
FileUploading.defaultProps = {
  image: {},
  width: 300
};
exports.default = FileUploading;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/cape-mixer/lib/FileUpload/FileUploading.js
// module id = 689
// module chunks = 0